const href = window.location.href;
const domain = href.substring(0, href.lastIndexOf('/')) + '/';

export const availableLanguages = [
  'en_US',
  'de_DE',
  'en_MY',
  'en_AU',
  'zh_CN',
  'en_HK',
  'en_IN',
  'ja_JP',
  'ko_KR',
  'en_NZ',
  'en_SG',
  'zh_TW',
  'fr_BE',
  'nl_BE',
  'cs_CZ',
  'da_DK',
  'en_NL',
  'fr_FR',
  'fi_FI',
  'hu_HU',
  'it_IT',
  'en_AE',
  'nl_NL',
  'nb_NO',
  'pl_PL',
  'pt_PT',
  'ru_RU',
  'en_ZA',
  'es_ES',
  'sv_SE',
  'de_CH',
  'fr_CH',
  'it_CH',
  'tr_TR',
  'en_GB',
  'pt_BR',
  'en_CA',
  'fr_CA',
  'es_MX',
  'es_LA',
];

let tealiumUrlTemp = 'https://tags.tiqcdn.com/utag/autodesk/uhm-qa/qa/utag.js';

if (process.env.REACT_APP_TIER === 'prd') {
  tealiumUrlTemp = 'https://tags.tiqcdn.com/utag/autodesk/uhm/prod/utag.js';
}

let siteTierConfig;
if (process.env.REACT_APP_TIER === 'prd') {
  siteTierConfig = {
    sessionLambdaUrl:
      'https://udklrynjp5.execute-api.us-east-1.amazonaws.com/PROD',
    oxygenTier: 'production',
    oxygenCallbackUrl: domain + 'oxygen_openid_response.html',
  };
} else {
  siteTierConfig = {
    sessionLambdaUrl:
      'https://6zqbylrbda.execute-api.us-east-1.amazonaws.com/STAGE',
    oxygenTier: 'staging',
    oxygenCallbackUrl: domain + 'oxygen_openid_response.html',
  };
}

export const tealiumUrl = tealiumUrlTemp;
export { siteTierConfig };
